
// playground requires you to assign document definition to a variable called dd
export const collectionBookReport = ({buyers }) => {
    var dd =  {
		content: [
			{ text: 'COLLECTION BOOK\n', style: "topHeader1" },
			{
				table: {
						body: [
						[
							{ text: 'Buyer Name', style: "gstHeader" },
							{ text: 'Remaining Amount', style: "gstHeader"},
							{ text: 'Mobile No.', style: "gstHeader" },
							{ text: 'Address', style: "gstHeader" },
							{ text: 'Tehsil', style: "gstHeader" },
							{ text: 'District', style: "gstHeader"},
							{ text: 'State', style: "gstHeader" },
						],
					
						]
				}
			},
		],
		styles: {
			gstHeader: {
				fontSize: 12,
				bold: true,
				alignment: 'center'
			},
			data: {
				fontSize: 9,
				alignment: 'center'
            },
            data2: {
				fontSize: 9,
                alignment: 'right',
                color: '#FF0000',
            },
            data3: {
				fontSize: 10,
                alignment: 'right',
                color: '#FF0000',
                bold: true,
			},
			topHeader1: {
				fontSize: 14,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d',
			},
		}
	}


    buyers.map((buyer) => {
		if(!!parseInt(buyer.remainingBalance) && !buyer.isTotal) {
			dd.content[1].table.body.push(
                [
                    { text: buyer.name  || '-' , style: "data" },
                    { text: Number.parseFloat(buyer.remainingBalance).toFixed(2) , style: "data2"},
                    { text: buyer.mobile  || '-'  , style: "data" },
                    { text: buyer.localAddress , style: "data" },
                    { text: buyer.tehsil , style: "data" },
                    { text: buyer.district , style: "data"},
                    { text: buyer.state , style: "data" },
                ]
            )
		} else {
			dd.content[1].table.body.push(
				[
					{ text: 'Total' , style: "data" },
					{ text: Number.parseFloat(buyer.total).toFixed(2) , style: "data3"},
					{ text: '' , style: "data"},
					{ text: '' , style: "data"},
					{ text: '' , style: "data"},
					{ text: '' , style: "data"},
					{ text: '' , style: "data"},
				]
			)
		}

    })
  
    return dd;
}




// WEBPACK FOOTER //
// ./src/utils/pdf-reports/collectionBookReport.js